import React, { useEffect, useState } from "react";

import { fetchAttachmentBlobUrl } from "@/api/product-dev";
import { cn } from "@/lib/utils";

/** <img> для загруженного файла: тянет blob под аутентификацией (Bearer в заголовке,
 * которого обычный <img src> не умеет) и показывает через object-URL. */
export function AuthImage({
  attId,
  className,
  alt = "",
}: {
  attId: string;
  className?: string;
  alt?: string;
}): React.ReactElement {
  const [src, setSrc] = useState<string | null>(null);

  useEffect(() => {
    let alive = true;
    let url: string | null = null;
    fetchAttachmentBlobUrl(attId)
      .then((u) => {
        url = u;
        if (alive) setSrc(u);
        else URL.revokeObjectURL(u);
      })
      .catch(() => undefined);
    return () => {
      alive = false;
      if (url) URL.revokeObjectURL(url);
    };
  }, [attId]);

  if (!src) return <div className={cn("animate-pulse bg-muted", className)} />;
  return <img src={src} alt={alt} className={className} />;
}
